// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"ActivateProjectCP_subTitle__1NaKd","modalLabel":"ActivateProjectCP_modalLabel__27_uo","modalContent":"ActivateProjectCP_modalContent__3PAgS"};